import { api } from 'api';
import { call } from 'redux-saga/effects';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Uploads a single integration file. Wrapped by operationWrapper for
// tenantId + JwtFeature.Internal guards and toast-on-failure. The caller
// (the page saga) re-triggers the file list fetch on completion so the
// table picks up the new row.
export function* uploadFile(args: { file: File }) {
  function* work(tenantId: string) {
    yield call(api.uploadFile, { tenantId, file: args.file });
  }

  yield call(operationWrapper, work, JwtFeature.Internal);
}
